<template>
	<!-- 右侧交易面板 - 固定在预留的右侧空间 -->
	<div v-if="showPanel" class="rightPC trading-panel">
		<!-- 账户信息卡片 - 完全对标st5-pc -->
	<div v-if="isUserLoggedIn" class="account-info-card" @click.stop.prevent="handleAccountClick" style="cursor: pointer;">
		<div class="account-uid">UID : {{ userInfo.inviteNumber || userInfo.id || '' }}</div>
		<div class="account-label">{{ currentAccountLabel }}</div>
		<div class="account-balance" :class="{ 'balance-negative': currentAvailableBalance < 0 }">
			{{ currentAvailableBalance.toFixed(2) }}
		</div>
	</div>
		
	<!-- 未登录提示 -->
	<div v-else class="account-info-card login-prompt-card" @click="handleLoginClick" style="cursor: pointer;">
		<div style="font-size: 16px; font-weight: 600; margin-bottom: 10px;">{{ $t('login.welcomeLogin') || 'Welcome Login' }}</div>
		<div style="font-size: 14px; opacity: 0.8;">{{ $t('Trading.loginToTrade') || 'Please login to start trading' }}</div>
	</div>

	<!-- 交易区域容器 - 独立的圆角框 -->
	<div class="trading-area-card">
	<!-- Tab切换 - 只保留合约和期权两个主标签 -->
	<div class="tab-switch-container">
			<div class="tab-switch-wrapper">
				<div
					:class="['trade-tab', { 'trade-tab-active': localMainTradeType === 'contract' }]"
					@click="localMainTradeType = 'contract'"
				>
					{{ $t('Market.contract') || '合约' }}
				</div>
				<div
					:class="['trade-tab', { 'trade-tab-active': localMainTradeType === 'options' }]"
					@click="localMainTradeType = 'options'"
				>
					{{ $t('Market.options') || '期权' }}
				</div>
			</div>
		</div>

		<!-- 品种信息面板 - 完全对标st5-pc -->
		<div class="symbol-info-panel">
			<div class="symbol-code">{{ selectedStock ? (selectedStock.appName || selectedStock.show_name || selectedStock.code) : '' }}</div>
			<div class="symbol-price">{{ selectedStock ? selectedStock.price : '' }}</div>
		</div>

		<!-- 合约内部的市价/挂单切换 -->
		<div v-if="localMainTradeType === 'contract'" class="contract-sub-tabs">
			<div class="sub-tab-wrapper">
				<div
					:class="['sub-tab-item', { 'active': localContractSubType === 'market' }]"
					@click="localContractSubType = 'market'"
				>
					{{ $t('Market.marketPrice') || '市价' }}
				</div>
				<div
					:class="['sub-tab-item', { 'active': localContractSubType === 'pending' }]"
					@click="localContractSubType = 'pending'"
				>
					{{ $t('Market.pendingOrder') || '挂单' }}
				</div>
			</div>
		</div>

	<!-- 交易表单区域 -->
	<div class="section-area">
			<!-- 市价交易表单 -->
			<div v-if="localMainTradeType === 'contract' && localContractSubType === 'market'" class="xiadanheyue" style="padding: 0 15px 10px; width: 100%; font-size: 12px;">
				<!-- 杠杆倍数选择 - 进度条样式 -->
				<div class="form-label-row" style="margin-bottom: 8px;">
					<div class="form-label-text">{{ $t('Trading.multiplier') || 'Multiplier' }}</div>
					<div class="form-label-value">{{ localMultiplier }}x</div>
				</div>
				<el-slider 
					v-model="localMultiplier" 
					:min="1" 
					:max="128" 
					:step="1"
					:show-tooltip="false"
					:marks="{ 1: '1x', 20: '20x', 50: '50x', 100: '100x', 128: '128x' }"
					style="margin-bottom: 10px;"
				></el-slider>

				<!-- 止损 -->
				<div class="form-label-row" style="margin-bottom: 5px; margin-top: 10px;">
					<div class="form-label-text">{{ $t('Trading.stopLoss') || 'Stop Loss' }}</div>
					<div>
						<el-switch v-model="localStopLossEnabled"></el-switch>
					</div>
				</div>
				<el-input-number
					style="width: 100%;"
					size="mini"
					:min="0"
					v-model="localStopLoss"
					:disabled="!localStopLossEnabled"
				></el-input-number>

				<!-- 止盈 -->
				<div class="form-label-row" style="margin-bottom: 5px; margin-top: 10px;">
					<div class="form-label-text">{{ $t('Trading.takeProfit') || 'Take Profit' }}</div>
					<div>
						<el-switch v-model="localTakeProfitEnabled"></el-switch>
					</div>
				</div>
				<el-input-number
					style="width: 100%;"
					size="mini"
					:min="0"
					v-model="localTakeProfit"
					:disabled="!localTakeProfitEnabled"
				></el-input-number>

				<!-- 购买数量 -->
				<div class="form-label-row" style="margin-bottom: 5px; margin-top: 10px;">
					<div class="form-label-text">{{ $t('Trading.buyQuantity') || 'Buy Quantity' }}</div>
				</div>
				<el-input-number
					style="width: 100%;"
					size="mini"
					:step="1"
					v-model="localQuantity"
					:min="1"
					:max="999999999"
					:precision="0"
					@keydown.native="preventNonNumericInput"
					@input="localQuantity = sanitizeIntegerInput(localQuantity, 1)"
				></el-input-number>

				<!-- 交易信息 -->
				<div class="trading-info-container">
					<div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.each') || 'Each' }}</span>
						<span class="trading-info-value">1{{ $t('Trading.Lots') || '手' }} = {{ marginPerLot }} USD</span>
					</div>
					<div class="trading-info-row"> 
						<span class="trading-info-label">{{ $t('Trading.estimatedCommission') || 'Estimated commission' }}</span>
						<span class="trading-info-value">{{ estimatedMarketCommission }}</span>
					</div>
					<div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.estimatedMargin') || 'Estimated Margin' }}</span>
						<span class="trading-info-value">{{ contractsInfoMargin.toFixed(1) }}</span>
					</div>
				</div>

				<!-- 交易按钮 - 完全对标st5-pc -->
				<div class="trading-buttons-container">
					<div class="trading-buttons-wrapper">
					<button 
						@click="(isUserLoggedIn && isTradingSupported) ? handlePlaceTrade('buy') : (isUserLoggedIn ? null : handleLoginClick())" 
						class="trade-btn trade-btn-buy" 
						:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
						:disabled="!isUserLoggedIn || !isTradingSupported">
						{{ $t('Market.buy') || 'Buy' }}
					</button>
					<button 
						@click="(isUserLoggedIn && isTradingSupported) ? handlePlaceTrade('sell') : (isUserLoggedIn ? null : handleLoginClick())" 
						class="trade-btn trade-btn-sell" 
						:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
						:disabled="!isUserLoggedIn || !isTradingSupported">
						{{ $t('Market.sell') || 'Sell' }}
					</button>
					</div>
				</div>
			</div>

			<!-- 挂单交易表单 -->
			<div v-if="localMainTradeType === 'contract' && localContractSubType === 'pending'" class="xiadanheyue pending-order-form">
				<!-- Price 价格 -->
				<div class="form-field">
					<div class="field-label">{{ $t('Trading.price') || 'Price' }}</div>
					<el-input-number
						style="width: 100%;"
						size="mini"
						:min="0"
						:precision="2"
						v-model="localPendingPrice"
						placeholder=""
						:controls="false"
					></el-input-number>
				</div>

			<!-- Multiplier 杠杆倍数选择 - 滑块样式，与Place a trade保持一致 -->
			<div style="margin-bottom: 6px;">
				<div class="form-label-row" style="margin-bottom: 6px;">
					<div class="form-label-text">{{ $t('Trading.multiplier') || 'Multiplier' }}</div>
					<div class="form-label-value">{{ localPendingMultiplier }}x</div>
				</div>
				<el-slider
					v-model="localPendingMultiplier"
					:min="1"
					:max="128"
					:step="1"
					:show-tooltip="false"
					:marks="{ 1: '1x', 20: '20x', 50: '50x', 100: '100x', 128: '128x' }"
					style="margin-bottom: 8px;"
				></el-slider>
			</div>

			<!-- Stop Loss 止损 -->
			<div style="margin-bottom: 6px;">
				<div class="form-label-row" style="margin-bottom: 4px;">
					<div class="form-label-text">{{ $t('Trading.stopLoss') || 'Stop Loss' }}</div>
					<el-switch v-model="localPendingStopLossEnabled" size="mini"></el-switch>
				</div>
				<el-input-number
					style="width: 100%;"
					size="mini"
					:min="0"
					:precision="2"
					v-model="localPendingStopLoss"
					placeholder="0"
					:controls="false"
					:disabled="!localPendingStopLossEnabled"
				></el-input-number>
			</div>

			<!-- Take Profit 止盈 -->
			<div style="margin-bottom: 6px;">
				<div class="form-label-row" style="margin-bottom: 4px;">
					<div class="form-label-text">{{ $t('Trading.takeProfit') || 'Take Profit' }}</div>
					<el-switch v-model="localPendingTakeProfitEnabled" size="mini"></el-switch>
				</div>
				<el-input-number
					style="width: 100%;"
					size="mini"
					:min="0"
					:precision="2"
					v-model="localPendingTakeProfit"
					placeholder="0"
					:controls="false"
					:disabled="!localPendingTakeProfitEnabled"
				></el-input-number>
			</div>

			<!-- Buy Quantity 购买数量 -->
			<div style="margin-bottom: 6px;">
					<div class="form-label-text" style="margin-bottom: 5px;">{{ $t('Trading.buyQuantity') || 'Buy Quantity' }}</div>
					<div style="display: flex; align-items: center;">
						<el-input-number
					style="width: 100%;"
					size="mini"
					:step="1"
					v-model="localQuantity"
					:min="1"
					:max="999999999"
					:precision="0"
					@keydown.native="preventNonNumericInput"
					@input="localQuantity = sanitizeIntegerInput(localQuantity, 1)"
				></el-input-number>
					</div>
				</div>

				<!-- 交易信息显示 -->
				<div class="trading-info-container pending-info">
					<div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.each') || 'Each' }}</span>
						<span class="trading-info-value">1{{ $t('Trading.Lots') || '手' }} = {{ marginPerLot }} USD</span>
					</div>
					<div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.estimatedCommission') || 'Estimated commission' }}</span>
						<span class="trading-info-value">{{ estimatedCommission }}</span>
					</div>
					<div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.estimatedMargin') || 'Estimated Margin' }}</span>
						<span class="trading-info-value">{{ contractsInfoMargin.toFixed(1) }}</span>
					</div>
					<!-- <div class="trading-info-row">
						<span class="trading-info-label">{{ $t('Trading.balance') || 'Balance' }}</span>
						<span class="trading-info-value">{{ (users.usdt || 0).toFixed(3) }}</span>
					</div> -->
				</div>

			<!-- Buy Up / Buy Down 按钮 -->
			<div class="pending-buttons-container">
				<div class="pending-buttons-wrapper">
			<button 
				@click="(isUserLoggedIn && isTradingSupported) ? handlePlacePendingOrder('buy') : (isUserLoggedIn ? null : handleLoginClick())" 
				class="pending-btn pending-btn-buy" 
				:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
				:disabled="!isUserLoggedIn || !isTradingSupported">
				{{ $t('Market.buy') || 'Buy' }}
			</button>
			<button 
				@click="(isUserLoggedIn && isTradingSupported) ? handlePlacePendingOrder('sell') : (isUserLoggedIn ? null : handleLoginClick())" 
				class="pending-btn pending-btn-sell" 
				:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
				:disabled="!isUserLoggedIn || !isTradingSupported">
				{{ $t('Market.sell') || 'Sell' }}
			</button>
				</div>
			</div>
			</div>

		<!-- 期权交易表单 -->
		<div v-if="localMainTradeType === 'options'" class="options-contract-form">
			<!-- 选择到期时间 - 网格布局 -->
				<div class="options-time-selection">
					<div class="time-title">{{ $t('Market.H5.selectExpiryTime') || '选择到期时间' }}</div>
					<div class="time-grid-wrapper">
						<div
							v-for="(option, index) in optionsInfo"
							:key="index"
							:class="['time-item', { 'active': localOptionsIndex === index }]"
							@click="handleSelectOptionsTime(index)"
						>
							{{ option.seconds }}s
						</div>
					</div>
				</div>

				<!-- 3. 预计收益率 -->
				<div class="options-profit-row">
					<span class="profit-label-gray">{{ $t('Market.H5.expectedReturn') || '预计收益率' }}</span>
					<span class="profit-value-black">{{ currentOptionsRate }}%</span>
				</div>

			<!-- 4. 交易数量容器 -->
			<div class="options-trade-quantity-box">
				<div class="quantity-title">
					{{ $t('Trading.buyQuantity') || '交易数量' }} 
					<span>(>{{ optionsInfo[localOptionsIndex] ? optionsInfo[localOptionsIndex].min : 100 }})</span>
				</div>
				<div class="quantity-input-box">
					<input 
						v-model.number="localOptionsMoney" 
						type="number" 
						class="quantity-input-field"
						:placeholder="'最小: ' + (optionsInfo[localOptionsIndex] ? optionsInfo[localOptionsIndex].min : 100)"
						:min="optionsInfo[localOptionsIndex] ? optionsInfo[localOptionsIndex].min : 100"
						@focus="showAmountDropdown = false"
					/>
					<div class="arrow-down" :class="{ 'arrow-up': showAmountDropdown }" @click="toggleAmountDropdown">›</div>
					
					<!-- 快捷金额下拉菜单 -->
					<div v-if="showAmountDropdown" class="amount-dropdown" @click.stop>
						<div 
							v-for="amount in quickAmounts" 
							:key="amount"
							class="amount-option"
							@click="selectQuickAmount(amount)"
						>
							{{ amount }}
						</div>
					</div>
				</div>
				<div class="expected-profit-row">
					<span>{{ $t('Trading.expectedProfit') || '预期收益' }}</span>
					<span>{{ ((localOptionsMoney * currentOptionsRate / 100) || 2).toFixed(0) }} USD</span>
				</div>
			</div>

				<!-- 5. 买涨/买跌按钮 -->
			<div class="options-action-buttons">
				<button
					@click="(isUserLoggedIn && isTradingSupported) ? handlePlaceOptionsContract('1') : (isUserLoggedIn ? null : handleLoginClick())"
					class="action-btn buy-up-btn"
					:disabled="optionsLoading || !isUserLoggedIn || !isTradingSupported"
					:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
				>
					<span v-if="optionsLoading">{{ $t('Trading.processing') }}</span>
					<span v-else>{{ $t('Trading.buyUp') || '买涨' }}</span>
				</button>
				<button
					@click="(isUserLoggedIn && isTradingSupported) ? handlePlaceOptionsContract('2') : (isUserLoggedIn ? null : handleLoginClick())"
					class="action-btn buy-down-btn"
					:disabled="optionsLoading || !isUserLoggedIn || !isTradingSupported"
					:class="{ 'disabled': !isUserLoggedIn || !isTradingSupported }"
				>
					<span v-if="optionsLoading">{{ $t('Trading.processing') }}</span>
					<span v-else>{{ $t('Trading.buyDown') || '买跌' }}</span>
				</button>
		</div>
		</div>
	</div>
	<!-- 交易区域容器结束 -->

		<!-- 期权倒计时弹窗 -->
		<div v-if="optionsPop" class="options-popup-overlay" @click="handleCloseOptionsPopup">
				<div class="options-popup" @click.stop>
					<div class="popup-header">
						<h3>{{ selectedStock ? (selectedStock.appName || selectedStock.show_name || selectedStock.code) : 'BTC/USD' }}</h3>
						<div class="header-right">
							<!-- 倒计时圆圈 -->
							<div v-if="optionsTime > 0" class="countdown-circle">
								{{ optionsTime }}s
							</div>
							<!-- 结果展示 -->
							<div v-else-if="optionsOrderInfo.resultType" class="result-display">
								<div v-if="optionsOrderInfo.resultType === 1" class="result-win">
									+{{ optionsOrderInfo.income || '0' }} USD
								</div>
								<div v-else class="result-lose">
									{{ optionsOrderInfo.income || '0' }} USD
								</div>
							</div>
							
							<!-- 关闭按钮 -->
							<button class="close-btn" @click="handleCloseOptionsPopup">×</button>
						</div>
					</div>
					<div class="popup-content">
						<div class="order-info">
							<div class="info-item">
								<span class="label">{{ $t('Trading.openPrice') || '开仓价' }}:</span>
								<span class="value">{{ optionsOrderInfo.buyPrice || optionsBuyPrice }} USD</span>
							</div>
							<div class="info-item">
								<span class="label">{{ $t('Trading.currentPrice') || '当前价' }}:</span>
								<span class="value">{{ optionsOrderInfo.endPrice || optionsCurrentPrice }} USD</span>
							</div>
							<div class="info-item">
								<span class="label">{{ optionsBuyType === '1' ? $t('Trading.up') : $t('Trading.down') }}:</span>
								<span class="value" :class="optionsBuyType === '1' ? 'price-up' : 'price-down'">
									{{ optionsOrderInfo.amount || localOptionsMoney }} USD
								</span>
							</div>
							<div class="info-item">
								<span class="label">{{ $t('Trading.tradingFee') || '交易量' }}:</span>
								<span class="value">{{ optionsOrderInfo.tradeFee || '1.00' }} USD</span>
							</div>
							<div class="info-item">
								<span class="label">{{ $t('Trading.expectedProfit') || '预期利润' }}:</span>
								<span class="value" :class="getExpectedProfitClass()">
									{{ optionsOrderInfo.income || getExpectedProfit() }} USD
								</span>
							</div>
							<div class="info-item">
								<span class="label">{{ $t('Trading.orderId') || '订单' }}:</span>
								<span class="value">{{ orderId || '-' }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import request from '@/utils/request'
import { checkTradingTime } from '@/api/market.js'

export default {
	name: 'TradingPanel',
	props: {
		showPanel: Boolean,
		isUserLoggedIn: Boolean,
		userInfo: {
			type: Object,
			default: () => ({})
		},
		selectedStock: Object,
		mainTradeType: String,
		contractSubType: String,
		multiplier: Number,
		stopLoss: Number,
		takeProfit: Number,
		quantity: Number,
		stopLossEnabled: Boolean,
		takeProfitEnabled: Boolean,
		pendingPrice: Number,
		pendingMultiplier: Number,
		pendingStopLoss: Number,
		pendingTakeProfit: Number,
		pendingQuantity: Number,
		pendingStopLossEnabled: Boolean,
		pendingTakeProfitEnabled: Boolean,
		estimatedMarketCommission: [String, Number],
		contractsInfoMargin: Number,
		estimatedCommission: [String, Number],
		estimatedMargin: [String, Number],
		users: {
			type: Object,
			default: () => ({})
		},
		optionsInfo: Array,
		optionsIndex: Number,
		currentOptionsRate: [String, Number],
		optionsMoney: Number,
		optionsLoading: Boolean,
		optionsPop: Boolean,
		optionsTime: Number,
		optionsOrderInfo: {
			type: Object,
			default: () => ({})
		},
		optionsBuyPrice: [String, Number],
		optionsCurrentPrice: [String, Number],
		optionsBuyType: String,
		orderId: [String, Number]
	},
	data() {
		return {
			localMainTradeType: this.mainTradeType,
			localContractSubType: this.contractSubType,
			localMultiplier: this.multiplier,
			localStopLoss: this.stopLoss,
			localTakeProfit: this.takeProfit,
			localQuantity: this.quantity,
			localStopLossEnabled: this.stopLossEnabled,
			localTakeProfitEnabled: this.takeProfitEnabled,
			localPendingPrice: this.pendingPrice,
			localPendingMultiplier: this.pendingMultiplier,
			localPendingStopLoss: this.pendingStopLoss,
			localPendingTakeProfit: this.pendingTakeProfit,
			localPendingQuantity: this.pendingQuantity,
			localPendingStopLossEnabled: this.pendingStopLossEnabled,
			localPendingTakeProfitEnabled: this.pendingTakeProfitEnabled,
			localOptionsIndex: this.optionsIndex,
			localOptionsMoney: this.optionsMoney,
			showAmountDropdown: false, // 控制金额下拉菜单显示
			quickAmounts: [100, 200, 500, 1000, 2000, 5000, 10000], // 快捷金额选项
		accountBalances: { // 账户余额数据
			spotBalance: 0,
			spotAvailable: 0,
			contractBalance: 0,
			contractAvailable: 0,
			optionBalance: 0,
			optionAvailable: 0
		},
		
		// ✅ 交易状态相关
		currentTradingStatus: {
			canTrade: null,  // null=检查中, true=可交易, false=休市
			reason: '检查中...'
		},
		tradingStatusCheckTimer: null,
		
		// ✅ 余额刷新定时器
		balanceRefreshTimer: null
	}
},
	watch: {
		// 监听登录状态变化
		isUserLoggedIn(val) {
			if (val) {
				// 用户登录后获取余额
				this.fetchAccountBalances();
			} else {
				// 用户登出后清空余额
				this.accountBalances = {
					spotBalance: 0,
					spotAvailable: 0,
					contractBalance: 0,
					contractAvailable: 0,
					optionBalance: 0,
					optionAvailable: 0
				};
			}
		},
		mainTradeType(val) {
			this.localMainTradeType = val
		},
	localMainTradeType(val) {
		this.$emit('update:mainTradeType', val)
		// ✅ 交易类型切换时重新检查交易时间
		this.checkCurrentTradingTime()
	},
	
	// ✅ 监听币种变化，重新检查交易时间
	'selectedStock.id': {
		handler(newId, oldId) {
			if (newId && newId !== oldId) {
				this.checkCurrentTradingTime()
			}
		}
	},
		contractSubType(val) {
			this.localContractSubType = val
		},
		localContractSubType(val) {
			this.$emit('update:contractSubType', val)
		},
		multiplier(val) {
			this.localMultiplier = val
		},
		localMultiplier(val) {
			this.$emit('update:multiplier', val)
		},
		stopLoss(val) {
			this.localStopLoss = val
		},
		localStopLoss(val) {
			this.$emit('update:stopLoss', val)
		},
		takeProfit(val) {
			this.localTakeProfit = val
		},
		localTakeProfit(val) {
			this.$emit('update:takeProfit', val)
		},
		quantity(val) {
			this.localQuantity = val
		},
		localQuantity(val) {
			this.$emit('update:quantity', val)
		},
		stopLossEnabled(val) {
			this.localStopLossEnabled = val
		},
		localStopLossEnabled(val) {
			this.$emit('update:stopLossEnabled', val)
		},
		takeProfitEnabled(val) {
			this.localTakeProfitEnabled = val
		},
		localTakeProfitEnabled(val) {
			this.$emit('update:takeProfitEnabled', val)
		},
		pendingPrice(val) {
			this.localPendingPrice = val
		},
		localPendingPrice(val) {
			this.$emit('update:pendingPrice', val)
		},
		pendingMultiplier(val) {
			this.localPendingMultiplier = val
		},
		localPendingMultiplier(val) {
			this.$emit('update:pendingMultiplier', val)
		},
		pendingStopLoss(val) {
			this.localPendingStopLoss = val
		},
		localPendingStopLoss(val) {
			this.$emit('update:pendingStopLoss', val)
		},
		pendingTakeProfit(val) {
			this.localPendingTakeProfit = val
		},
		localPendingTakeProfit(val) {
			this.$emit('update:pendingTakeProfit', val)
		},
		pendingQuantity(val) {
			this.localPendingQuantity = val
		},
		localPendingQuantity(val) {
			this.$emit('update:pendingQuantity', val)
		},
		pendingStopLossEnabled(val) {
			this.localPendingStopLossEnabled = val
		},
		localPendingStopLossEnabled(val) {
			this.$emit('update:pendingStopLossEnabled', val)
		},
		pendingTakeProfitEnabled(val) {
			this.localPendingTakeProfitEnabled = val
		},
		localPendingTakeProfitEnabled(val) {
			this.$emit('update:pendingTakeProfitEnabled', val)
		},
		optionsIndex(val) {
			this.localOptionsIndex = val
		},
		localOptionsIndex(val) {
			this.$emit('update:optionsIndex', val)
		},
		optionsMoney(val) {
			this.localOptionsMoney = val
		},
		localOptionsMoney(val) {
			this.$emit('update:optionsMoney', val)
		}
	},
	computed: {
		// 每手保证金（不随手数变化）
		marginPerLot() {
			const total = Number(this.contractsInfoMargin || 0)
			const quantity = Number(this.localQuantity || 0)
			if (!total || !quantity) return '0.0'
			return (total / quantity).toFixed(1)
		},

		// 当前账户类型标签
		currentAccountLabel() {
			if (this.localMainTradeType === 'contract') {
				return this.$t('transfer.contractAccount') || '合约账户';
			} else if (this.localMainTradeType === 'options') {
				return this.$t('transfer.optionAccount') || '期权账户';
			} else {
				return this.$t('Trading.availableFunds') || '可用资金';
			}
		},
	// 当前可用余额
	// ✅ 使用 Balance（总余额）而不是 Available（可用余额），以正确显示负数
	currentAvailableBalance() {
		let balance = 0;
		if (this.localMainTradeType === 'contract') {
			balance = this.accountBalances.contractBalance ?? 0;
		} else if (this.localMainTradeType === 'options') {
			balance = this.accountBalances.optionBalance ?? 0;
		} else {
			balance = this.accountBalances.spotBalance ?? 0;
		}
		
		return Number(balance);
	},
	
	// ✅ 检查当前币种是否支持选定的交易类型 + 是否在交易时间内
	isTradingSupported() {
		if (!this.selectedStock) return false;
		
		// 1. 首先检查交易类型支持
		let typeSupported = false;
		
		// 合约交易：检查 canContracts === 1
		if (this.localMainTradeType === 'contract') {
			typeSupported = this.selectedStock.canContracts === 1;
		}
		// 期权交易：检查 canOptions === 1
		else if (this.localMainTradeType === 'options') {
			typeSupported = this.selectedStock.canOptions === 1;
		}
		else {
			// 其他类型默认支持
			typeSupported = true;
		}
		
		// 2. 检查交易时间（null表示检查中，不阻止交易）
		const timeSupported = this.currentTradingStatus.canTrade === true || this.currentTradingStatus.canTrade === null;
		
		return typeSupported && timeSupported;
	}
	},
	methods: {
		sanitizeIntegerInput(value, min = 1) {
			const num = parseInt(value, 10)
			if (Number.isNaN(num)) return min
			return Math.max(min, num)
		},

		preventDecimalInput(e) {
			const blockedKeys = ['.', ',', 'e', 'E', '+', '-', ' ']
			if (blockedKeys.includes(e.key)) {
				e.preventDefault()
			}
		},

		preventNonNumericInput(e) {
			// 允许：数字、删除/退格、方向键、Tab、Enter、Home/End
			const allowedKeys = [
				'Backspace',
				'Delete',
				'Tab',
				'Enter',
				'ArrowLeft',
				'ArrowRight',
				'ArrowUp',
				'ArrowDown',
				'Home',
				'End'
			]
			if (allowedKeys.includes(e.key)) return

			// 允许 Ctrl/Cmd + A/C/V/X
			if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(String(e.key).toLowerCase())) {
				return
			}

			// 允许 0-9
			if (/^\d$/.test(e.key)) return

			e.preventDefault()
		},
		// 获取账户余额
	async fetchAccountBalances() {
		if (!this.isUserLoggedIn) return;
		
		try {
			const res = await this.$http.get('/swx/customer/account/balances');
			if (res.code === 200 && res.result) {
				this.accountBalances = {
					spotBalance: res.result.spotBalance ?? 0,
					spotAvailable: res.result.spotAvailable ?? 0,
					contractBalance: res.result.contractBalance ?? 0,
					contractAvailable: res.result.contractAvailable ?? 0,
					optionBalance: res.result.optionBalance ?? 0,
					optionAvailable: res.result.optionAvailable ?? 0
				};
			}
		} catch (error) {
			console.error('获取账户余额失败:', error);
		}
	},
		handleAccountClick() {
			this.$emit('account-click')
		},
		handleLoginClick() {
			this.$emit('login-click')
		},
	handlePlaceTrade(type) {
		this.$emit('place-trade', type);
		// ✅ 移除延迟刷新，改由 home_pc.vue 在下单成功后立即刷新
	},
	handlePlacePendingOrder(type) {
		this.$emit('place-pending-order', type);
		// ✅ 移除延迟刷新，改由 home_pc.vue 在下单成功后立即刷新
	},
	handlePlaceOptionsContract(type) {
		this.$emit('place-options-order', type);
		// ✅ 移除延迟刷新，改由 home_pc.vue 在下单成功后立即刷新
	},
		handleSelectOptionsTime(index) {
			this.localOptionsIndex = index
			this.$emit('select-options-time', index)
		},
		handleCloseOptionsPopup() {
			this.$emit('close-options-popup')
		},
		decreaseQuantity() {
			if (this.localPendingQuantity > 1) {
				this.localPendingQuantity--
			}
		},
		increaseQuantity() {
			this.localPendingQuantity++
		},
		getExpectedProfit() {
			return ((this.localOptionsMoney * this.currentOptionsRate / 100) || 0).toFixed(2)
		},
		getExpectedProfitClass() {
			if (this.optionsOrderInfo.resultType === 1) {
				return 'price-up'
			} else if (this.optionsOrderInfo.resultType === 2) {
				return 'price-down'
			}
			return ''
		},
		
		// 切换金额下拉菜单
		toggleAmountDropdown() {
			this.showAmountDropdown = !this.showAmountDropdown
		},
		
		// 选择快捷金额
		selectQuickAmount(amount) {
			this.localOptionsMoney = amount
			this.showAmountDropdown = false
		},
		
	// 点击外部关闭下拉菜单
	handleClickOutside(event) {
		// 确保 $el 存在且是一个有效的 DOM 元素
		if (!this.$el || typeof this.$el.querySelector !== 'function') {
			return
		}
		
		const dropdown = this.$el.querySelector('.amount-dropdown')
		const inputBox = this.$el.querySelector('.quantity-input-box')
		if (dropdown && inputBox && !inputBox.contains(event.target)) {
			this.showAmountDropdown = false
		}
	},
	
	// ========== 交易状态检查相关方法 ==========
	// 检查当前币种的交易时间
	async checkCurrentTradingTime() {
		if (!this.selectedStock || !this.selectedStock.id) {
			return
		}
		
		try {
			// 根据当前交易类型决定tradeType参数
			// contract = 1（合约）, options = 2（期权）
			const tradeType = this.localMainTradeType === 'contract' ? 1 : 2
			
			const res = await checkTradingTime({
				marketId: this.selectedStock.id,
				tradeType: tradeType
			})
			
			if (res.code === 200) {
				this.currentTradingStatus = {
					canTrade: res.result.canTrade,
					reason: res.result.reason,
					currentTime: res.result.currentTime
				}
			} else {
				this.currentTradingStatus = {
					canTrade: false,
					reason: res.msg || '无法获取交易状态'
				}
			}
		} catch (error) {
			console.error('检查交易时间失败:', error)
			this.currentTradingStatus = {
				canTrade: false,
				reason: '网络错误，请稍后重试'
			}
		}
	}
},
	
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
		// 组件挂载时获取账户余额
		this.fetchAccountBalances();
		
		// ✅ 首次检查交易时间
		if (this.selectedStock && this.selectedStock.id) {
			this.checkCurrentTradingTime()
		}
		
		// ✅ 每分钟更新一次交易状态
		this.tradingStatusCheckTimer = setInterval(() => {
			this.checkCurrentTradingTime()
		}, 60000)
		
		// ✅ 每10秒刷新一次余额
		this.balanceRefreshTimer = setInterval(() => {
			if (this.isUserLoggedIn) {
				this.fetchAccountBalances();
			}
		}, 10000)
	},
	
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside)
		
		// ✅ 清理交易状态检查定时器
		if (this.tradingStatusCheckTimer) {
			clearInterval(this.tradingStatusCheckTimer)
			this.tradingStatusCheckTimer = null
		}
		
		// ✅ 清理余额刷新定时器
		if (this.balanceRefreshTimer) {
			clearInterval(this.balanceRefreshTimer)
			this.balanceRefreshTimer = null
		}
	}
}
</script>

<style scoped>
/* 交易面板样式 */
.trading-panel {
	position: relative;
	top: 0;
	right: 0;
	width: 324px;
	min-height: 770px;
	height: auto;
	z-index: 1;
	background: transparent;
	padding: 0;
	box-sizing: border-box;
	margin-right: 12px;
	display: flex;
	flex-direction: column;
}

/* 交易区域独立卡片样式 */
.trading-area-card {
	background: var(--card-bg);
	border-radius: 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
	border: 1px solid rgba(0, 0, 0, 0.02);
	margin-top: 12px;
	padding: 12px;
	transition: background-color 0.3s ease;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
}

/* 账户信息卡片样式 */
.account-info-card {
	padding: 16px 20px;
	margin-top: 18px;
	margin-bottom: 10px;
	margin-left: 0;
	margin-right: 0;
	background-color: var(--primary-color, #0156DC);
	border-radius: 12px;
	color: #ffffff;
	text-align: center;
	box-shadow: 0 2px 8px rgba(1, 102, 252, 0.2);
	transition: all 0.3s ease;
	position: relative;
	z-index: 1;
	flex-shrink: 0;
}

.account-info-card:hover {
	box-shadow: 0 4px 12px rgba(1, 102, 252, 0.3);
	transform: translateY(-2px);
}

.account-uid {
	font-size: 13px;
	padding: 4px 0;
	opacity: 0.9;
}

.account-label {
	font-size: 12px;
	margin-bottom: 8px;
	opacity: 0.85;
}

.account-balance {
	font-weight: bold;
	font-size: 24px;
	letter-spacing: 0.5px;
}

/* 负数余额样式 */
.account-balance.balance-negative {
	color: #dc3545 !important;
	font-weight: 900 !important;
}

/* 品种信息面板样式 */
.symbol-info-panel {
	padding: 12px 8px;
	margin-top: 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.symbol-code {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.symbol-price {
	font-size: 20px;
	color: var(--primary-color, #0156DC);
	transition: color 0.3s ease;
}

/* Tab切换样式 */
.tab-switch-container {
	width: 100%;
	margin-top: 0;
}

.tab-switch-wrapper {
	display: flex;
	width: 100%;
	background: transparent;
	border-radius: 4px;
	overflow: hidden;
	padding: 9px;
	transition: background-color 0.3s ease;
}

.trade-tab {
	flex: 1;
	text-align: center;
	padding: 8px 12px;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.3s ease;
	background: transparent;
	color: var(--text-secondary);
	font-weight: 500;
	border-radius: 4px;
}

.trade-tab:hover {
	background: var(--hover-bg, var(--primary-color-10));
}

.trade-tab-active {
	background: var(--primary-color, #0156DC) !important;
	color: white !important;
	font-weight: 600;
}

/* 合约子标签样式（市价/挂单） */
.contract-sub-tabs {
	width: 100%;
	margin-top: 12px;
	padding: 0;
}

.sub-tab-wrapper {
	display: flex;
	gap: 10px;
	background: transparent;
	padding: 4px;
	border-radius: 6px;
	transition: background-color 0.3s ease;
}

.sub-tab-item {
	flex: 1;
	text-align: center;
	padding: 8px 12px;
	cursor: pointer;
	font-size: 13px;
	transition: all 0.3s ease;
	background: transparent;
	color: var(--text-secondary);
	border-radius: 4px;
	font-weight: 500;
}

.sub-tab-item:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}

.sub-tab-item.active {
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	color: var(--text-primary);
	font-weight: 600;
	box-shadow: var(--card-shadow, 0 1px 3px rgba(0, 0, 0, 0.1));
}

/* 交易表单区域 */
.section-area {
	width: 100%;
	padding: 0;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.xiadanheyue {
	margin-top: 12px;
	padding: 0;
	width: 100%;
	font-size: 12px;
	box-sizing: border-box;
}

/* 表单标签行样式 */
.form-label-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.form-label-text {
	font-size: 12px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.form-label-value {
	font-size: 14px;
	font-weight: bold;
	color: var(--primary-color, #0156DC);
	transition: color 0.3s ease;
}

/* 交易信息容器样式 - 统一三个标签页的样式 */
.trading-info-container {
	width: 100%;
	font-size: 12px;
	font-weight: bold;
	padding: 8px 0;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.trading-info-container.pending-info {
	margin-bottom: 10px;
	font-size: 12px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: bold;
	padding: 8px 0;
}

.trading-info-row {
	display: flex;
	line-height: 18px;
	margin-top: 6px;
	justify-content: space-between;
}

.trading-info-row:first-child {
	margin-top: 0;
}

.trading-info-label {
	flex: 1;
	font-weight: bold;
	color: var(--text-secondary);
	transition: color 0.3s ease;
}

.trading-info-value {
	color: var(--text-primary);
	font-weight: bold;
	transition: color 0.3s ease;
}

/* 期权表单容器 */
.options-contract-form {
	padding: 0;
	margin-top: 15px;
	width: 100%;
	box-sizing: border-box;
}

/* 1. 品种信息卡片 */
.options-symbol-card {
	background: transparent;
	border-radius: 8px;
	margin-top: 12px;
	margin-bottom: 12px;
	transition: background-color 0.3s ease;
}

.symbol-header {
	background: transparent;
	padding: 14px 20px 10px;
	border-radius: 8px 8px 0 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	transition: background-color 0.3s ease;
}

.symbol-name {
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-size: 14px;
}

.symbol-price-up {
	color: var(--danger-color, #ff4d4f);
	font-size: 16px;
	font-weight: 600;
	transition: color 0.3s ease;
}

/* 2. 选择到期时间区域 */
.options-time-selection {
	padding: 12px 15px;
	background: transparent;
	border-radius: 8px;
	margin-top: 12px;
	margin-bottom: 12px;
	transition: background-color 0.3s ease;
}

.time-title {
	color: var(--text-primary, #111);
	font-weight: 500;
	font-size: 14px;
	margin-bottom: 10px;
	transition: color 0.3s ease;
}

.time-grid-wrapper {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: 10px;
}

.time-item {
	width: 60px;
	text-align: center;
	border-radius: 4px;
	padding: 10px 0;
	cursor: pointer;
	background: var(--card-bg);
	transition: all 0.3s ease;
	color: var(--text-primary, black);
	font-size: 13px;
	border: 1px solid var(--border-color, transparent);
}

.time-item:hover {
	border-color: var(--primary-color, #0156DC);
	box-shadow: 0 2px 4px var(--primary-color-20);
}

.time-item.active {
	background: var(--primary-color, #0156DC) !important;
	color: white !important;
	font-weight: 600;
	border-color: var(--primary-color, #0156DC);
}

/* 3. 预计收益率行 */
.options-profit-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 12px;
	padding: 0 20px;
}

.profit-label-gray {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	font-size: 13px;
}

.profit-value-black {
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-size: 14px;
	font-weight: 600;
}

/* 4. 交易数量容器 */
.options-trade-quantity-box {
	background: transparent;
	border-radius: 8px;
	margin-top: 12px;
	padding: 12px;
	border: 1px solid var(--border-light, transparent);
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.quantity-title {
	font-size: 13px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	margin-bottom: 10px;
}

.quantity-title span {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
}

.quantity-input-box {
	display: flex;
	align-items: center;
	background: var(--bg-secondary, #f5f5f5);
	border: 1px solid var(--border-color, transparent);
	border-radius: 8px;
	padding: 0 10px;
	height: 40px;
	position: relative;
	transition: all 0.3s ease;
}

.quantity-input-box:focus-within {
	border-color: var(--primary-color, #0156DC);
	background: var(--input-bg, #ffffff);
	box-shadow: 0 0 0 3px var(--primary-color-10);
}

.quantity-input-field {
	flex: 1;
	border: none;
	background: transparent;
	outline: none;
	font-size: 16px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	cursor: text;
}

.quantity-input-field::placeholder {
	color: var(--text-tertiary);
	transition: color 0.3s ease;
}

/* 隐藏 number 类型输入框的上下箭头 */
.quantity-input-field::-webkit-outer-spin-button,
.quantity-input-field::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.quantity-input-field[type="number"] {
	-moz-appearance: textfield;
}

.arrow-down {
	font-size: 18px;
	color: var(--text-tertiary);
	transition: all 0.3s ease;
	transform: rotate(90deg);
	cursor: pointer;
	padding: 5px;
	margin-left: 5px;
	user-select: none;
}

.arrow-down:hover {
	color: var(--primary-color, #0156DC);
	background: var(--hover-bg);
	border-radius: 4px;
}

.arrow-down.arrow-up {
	transform: rotate(-90deg);
}

/* 快捷金额下拉菜单 */
.amount-dropdown {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	margin-top: 4px;
	background: var(--card-bg, #ffffff);
	border: 1px solid var(--border-color, #e0e0e0);
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	max-height: 240px;
	overflow-y: auto;
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.amount-option {
	padding: 10px 15px;
	cursor: pointer;
	transition: all 0.2s ease;
	color: var(--text-primary, #333);
	font-size: 14px;
	border-bottom: 1px solid var(--border-light, #f0f0f0);
}

.amount-option:last-child {
	border-bottom: none;
}

.amount-option:hover {
	background: var(--hover-bg, var(--primary-color-8));
	color: var(--primary-color, #0156DC);
	padding-left: 20px;
}

.amount-option:active {
	background: var(--active-bg, var(--primary-color-15));
}

.expected-profit-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	margin-top: 8px;
	font-size: 13px;
}

/* 5. 买涨/买跌按钮 */
.options-action-buttons {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 15px;
	gap: 15px;
}

.action-btn {
	flex: 1;
	height: 40px;
	border-radius: 4px;
	border: none;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	outline: none;
	border-radius: 100px;
	color: white;
}

.action-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.buy-up-btn {
	background: var(--primary-color, #0156DC);
	border-color: var(--primary-color, #0156DC);
	width: 49%;
}

.buy-up-btn:hover:not(:disabled) {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 12px var(--primary-color-20);
}

.buy-down-btn {
	background: #f23c48;
	border-color: #f23c48;
}

.buy-down-btn:hover:not(:disabled) {
	background: #e22c38;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(242, 60, 72, 0.3);
}

/* 未登录状态的按钮样式 */
.buy-up-btn.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.buy-up-btn.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

.buy-down-btn.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.buy-down-btn.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

/* 交易按钮样式 */
.trading-buttons-container {
	width: 100%;
}

.trading-buttons-wrapper {
	display: flex;
	width: 100%;
}

.trade-btn {
	border: 0;
	font-size: 12px;
	height: 40px;
	color: #ffffff;
	line-height: 40px;
	border-radius: 100px;
	cursor: pointer;
	transition: all 0.2s;
	font-weight: bold;
}

.trade-btn-buy {
	background: var(--primary-color, #0156DC);
	width: 49%;
}

.trade-btn-buy:hover:not(.disabled) {
	background: var(--primary-dark);
}

.trade-btn-sell {
	background: #f23c48;
	width: 49%;
	margin-left: 13px;
}

.trade-btn-sell:hover:not(.disabled) {
	background: #e22c38;
}

/* 未登录时的市价交易按钮样式 - 更高优先级 */
.trade-btn-buy.disabled,
.trade-btn-sell.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.trade-btn-buy.disabled:hover,
.trade-btn-sell.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

/* 挂单表单样式 */
.pending-order-form {
	padding: 0;
	width: 100%;
	box-sizing: border-box;
}

.form-field {
	margin-bottom: 6px;
	margin-top: 6px;
}

.field-label {
	font-size: 12px;
	font-weight: bold;
	margin-bottom: 5px;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

/* 挂单按钮样式 */
.pending-buttons-container {
	width: 100%;
}

.pending-buttons-wrapper {
	display: flex;
	width: 100%;
	gap: 8px;
}

.pending-btn {
	border: 0;
	flex: 1;
	font-size: 12px;
	height: 40px;
	color: #ffffff;
	line-height: 40px;
	border-radius: 20px;
	font-weight: bold;
	cursor: pointer;
	transition: all 0.2s;
}

.pending-btn-buy {
	background: var(--primary-color, #0156DC);
}

.pending-btn-buy:hover {
	background: var(--primary-dark);
}

.pending-btn-sell {
	background: #f23c48;
}

.pending-btn-sell:hover {
	background: #e22c38;
}

/* 未登录状态的pending按钮样式 */
.pending-btn-buy.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.pending-btn-buy.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

.pending-btn-sell.disabled {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transition: background-color 0.3s ease, color 0.3s ease;
	cursor: not-allowed;
	opacity: 0.8;
}

.pending-btn-sell.disabled:hover {
	background: #ccc !important;
	color: var(--text-secondary, #666) !important;
	transform: none;
	box-shadow: none;
}

/* 期权弹窗样式 */
.options-popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.options-popup {
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 12px;
	width: 400px;
	max-width: 90%;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
	overflow: hidden;
}

/* 使用更具体的选择器，确保优先级 */
.options-popup-overlay .options-popup .popup-header {
	background: transparent;
	padding: 20px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.04);
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
	transition: background-color 0.3s ease, border-color 0.3s ease;
}

.options-popup-overlay .options-popup .header-right {
	display: flex;
	align-items: center;
	gap: 15px;
}

.options-popup-overlay .options-popup .popup-header h3 {
	margin: 0;
	font-size: 20px;
	font-weight: bold;
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.options-popup-overlay .options-popup .countdown-circle {
	width: 60px;
	height: 60px;
	border: 3px solid var(--primary-color);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	font-weight: bold;
	color: var(--primary-color, #0156DC);
	background: var(--card-bg);
	transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
	flex-shrink: 0;
}

.options-popup-overlay .options-popup .result-display {
	width: 60px;
	height: 60px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	flex-shrink: 0;
}

.options-popup-overlay .options-popup .result-win {
	color: #28a745;
	text-align: center;
}

.options-popup-overlay .options-popup .result-lose {
	color: #dc3545;
	text-align: center;
}

.options-popup-overlay .options-popup .close-btn {
	background: none;
	border: none;
	font-size: 28px;
	cursor: pointer;
	color: var(--text-tertiary);
	transition: color 0.3s ease;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.options-popup-overlay .options-popup .close-btn:hover {
	color: var(--text-primary);
	transition: color 0.3s ease;
}

.options-popup-overlay .options-popup .popup-content {
	padding: 20px;
	position: relative !important;
	transform: none !important;
	top: auto !important;
	left: auto !important;
	width: auto !important;
	min-width: auto !important;
	max-width: none !important;
}

.order-info {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.info-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;
	border-bottom: 1px solid var(--border-color, #f0f0f0);
	transition: border-color 0.3s ease;
}

.info-item:last-child {
	border-bottom: none;
}

.info-item .label {
	font-size: 14px;
	color: var(--text-secondary);
	transition: color 0.3s ease;
	font-weight: 500;
}

.info-item .value {
	font-size: 14px;
	color: var(--text-primary);
	transition: color 0.3s ease;
	font-weight: bold;
}

.price-up {
	color: var(--success-color, #28a745) !important;
}

.price-down {
	color: var(--danger-color, #dc3545) !important;
}

.rightPC {
	margin-top: 0;
}
</style>

<!-- Element UI 组件黑夜模式全局样式（非 scoped） -->
<style>
/* Element UI Slider 滑块样式 */
.el-slider__runway {
	background-color: var(--border-color, #e4e7ed) !important;
	transition: background-color 0.3s ease;
}

.el-slider__bar {
	background-color: var(--primary-color, #0156DC) !important;
}

.el-slider__button {
	border: 2px solid var(--primary-color, #0156DC) !important;
	background-color: var(--card-bg, #ffffff) !important;
	transition: all 0.3s ease;
}

.el-slider__button:hover {
	transform: scale(1.2);
}

.el-slider__stop {
	background-color: var(--border-color, #e4e7ed) !important;
}

.el-slider__marks-text {
	color: var(--text-secondary, #666) !important;
	transition: color 0.3s ease;
}

/* Element UI InputNumber 数字输入框样式 */
.el-input-number {
	background-color: transparent !important;
}

.el-input-number .el-input__inner {
	background-color: var(--input-bg, #ffffff) !important;
	border: 1px solid var(--border-color, #dcdfe6) !important;
	color: var(--text-primary, #333) !important;
	transition: all 0.3s ease;
}

.el-input-number .el-input__inner:hover {
	border-color: var(--primary-color, #0156DC) !important;
}

.el-input-number .el-input__inner:focus {
	border-color: var(--primary-color, #0156DC) !important;
}

.el-input-number .el-input__inner:disabled {
	background-color: var(--bg-secondary, #f5f7fa) !important;
	color: var(--text-tertiary, #999) !important;
	cursor: not-allowed;
}

.el-input-number__decrease,
.el-input-number__increase {
	background: var(--bg-primary, #ffffff) !important;
	border: 1px solid var(--border-color, #dcdfe6) !important;
	color: var(--text-primary, #333) !important;
	transition: all 0.3s ease;
}

.el-input-number__decrease:hover,
.el-input-number__increase:hover {
	color: var(--primary-color, #0156DC) !important;
	background: var(--hover-bg, rgba(1, 102, 252, 0.05)) !important;
}

.el-input-number.is-disabled .el-input-number__decrease,
.el-input-number.is-disabled .el-input-number__increase {
	background-color: var(--bg-secondary, #f5f7fa) !important;
	color: var(--text-tertiary, #999) !important;
	cursor: not-allowed;
}

/* Element UI Switch 开关样式 */
.el-switch__core {
	background-color: var(--border-color, #dcdfe6) !important;
	border: 1px solid var(--border-color, #dcdfe6) !important;
	transition: all 0.3s ease;
}

.el-switch.is-checked .el-switch__core {
	background-color: var(--primary-color, #0156DC) !important;
	border-color: var(--primary-color, #0156DC) !important;
}

.el-switch__label {
	color: var(--text-primary, #333) !important;
	transition: color 0.3s ease;
}

.el-switch__label.is-active {
	color: var(--primary-color, #0156DC) !important;
}

.el-switch.is-disabled .el-switch__core {
	background-color: var(--bg-secondary, #f5f7fa) !important;
	opacity: 0.6;
	cursor: not-allowed;
}
</style>
